/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
window.EvaluationsChart = {
  _rawData: {},
  _chartWidth: 0,
  _bidsOrder: [],
  _chart: null,
  _currentCategory: 'sections',
  _currentOrder: {
    name: 'bidder',
    direction: 'asc'
  },

  _cachedSeries: {
    sections: null,
    categories: null
  },
  _defYAxisConfig: {
    min: 0,
    max: 100,
    title: {
      text: ''
    },
    gridLineWidth: 0
  },

  _seriesBySection() {
    return this._cachedSeries.sections || this._generateSeriesBySection();
  },

  _seriesByCategory() {
    return this._cachedSeries.categories || this._generateSeriesByCategory();
  },

  _dataStruct(data, name) {
    return {
      data,
      name
    };
  },

  _generateSeriesByCategory() {
    const factors = {};
    _.each(this._rawData.bids, bid => {
      const evals = _.where(this._rawData.grouped_evaluations.by_category, {bid_id: bid.id});
      const sum = _.reduce(evals, ((memo, evaluation) => memo + evaluation.score), 0);
      return factors[bid.id] = bid.score / sum;
    });

    return this._cachedSeries.categories = _.map(['commercial', 'technical'], category => {
      const evals = _.where(this._rawData.grouped_evaluations.by_category, {category});

      const data = [];
      _.each(this._bidsOrder, function(id) {
        const evaluation = _.findWhere(evals, {bid_id: id});
        if (evaluation) {
          return data.push({
            y: evaluation.score * factors[evaluation.bid_id],
            meta: {
              category: evaluation.category,
              bidId: evaluation.bid_id
            }
          });
        } else {
          return 0;
        }
      });

      return this._dataStruct(data, category);
    });
  },

  _generateSeriesBySection() {
    const factors = {};
    _.each(this._rawData.bids, bid => {
      const evals = _.where(this._rawData.grouped_evaluations.by_template, {bid_id: bid.id});
      const sum = _.reduce(evals, ((memo, evaluation) => memo + evaluation.score), 0);
      return factors[bid.id] = bid.score / sum;
    });

    const sections = [];
    _.each(this._rawData.section_types, template_id => {
      const evals = _.where(this._rawData.grouped_evaluations.by_template, {id: template_id});
      const category_evals = _.partition(evals, template => template.category === 'technical');
      return _.each(category_evals, evaluations => {
        const data = [];
        _.each(this._bidsOrder, id => {
          const evaluation = _.findWhere(evaluations, {bid_id: id});
          if (evaluation) {
            return data.push({
              y: evaluation.score * factors[evaluation.bid_id],
              meta: {
                name: evaluation.title,
                bidId: evaluation.bid_id,
                category: evaluation.category,
                template_id: evaluation.id
              }
            });
          } else {
            return 0;
          }
          });
        if (!_.isEmpty(evaluations)) { return sections.push(this._dataStruct(data, _.template('<%= title %> (<%= category %>)')(_.first(evaluations)))); }
      });
    });
    this._cachedSeries.sections = sections;
    return sections;
  },

  _setWidth(selector) {
    return this._chartWidth = $(`#${selector}`).width();
  },

  _resetWidth(selector) {
    this._setWidth(selector);
    return this._drawChart(selector);
  },

  _drawToolTipTable(evaluators, bidEvaluations) {
    const rows = _.map(bidEvaluations, evaluation => {
      const state = evaluation['evaluated?'] ?
          `<td class='green'>${I18n.t('completed')}</td>`
        :
          `<td>${I18n.t('in_progress')}</td>`;

      return "<tr>" +
        `<td>${_.find(evaluators, {id: evaluation.evaluator_id}).name}</td>` +
        state +
        `<td class=\"${this._getColor(evaluation.score)}\">${_.isNaN(parseFloat(evaluation.score)) ? '---' : evaluation.score.toFixed(2)}</td>` +
      "</tr>";
  }).join('');

    return "<table class='evaluation-tooltip'>" +
    '<thead><th>Evaluator</th><th>Evaluation</th><th>Score</th></thead>' +
    '<tbody>' + rows + '</tbody>' +
    '</table>';
  },

  _drawStackLabelForBidder(bid) {
    return `<b>${bid.bidder_name}</b></br>` +
    `<div class='${this._getColor(bid.score)}'>${this._toPercent(bid.score)}</div>`;
  },

  _removeAllSeries() {
    return _.times(this._chart.series.length, () => this._chart.series[0].remove(false));
  },

  _getColor(score) {
    if (_.isNaN(parseFloat(score))) { return ''; }
    if (score < 60) {
      return 'pt-red';
    } else {
      return 'pt-green';
    }
  },

  _toPercent(score) {
    return `${Math.round(score * 100) / 100}%`;
  },

  changeCategories(event) {
    this._currentCategory = $(event.target).data('type');
    return this._redrawChart();
  },

  _redrawChart() {
    this._removeAllSeries();
    const series = this._currentCategory === 'sections' ?
      this._seriesBySection()
    :
      this._seriesByCategory();

    _.each(series, (serie, index) => {
      return this._chart.addSeries(serie, index === (series.length-1));
    });

    return this._blurNotFinishedEvaluations();
  },

  _sortBidders() {
    const bids = _.sortBy(this._rawData.bids, this._currentOrder.name);
    this._bidsOrder = _.map(bids, bid => bid.id);
    if (this._currentOrder.direction === 'desc') {
      return this._bidsOrder = this._bidsOrder.reverse();
    }
  },

  _changeOrder(event) {
    this._currentOrder.name = $(event.target).data('sortBy');
    this._currentOrder.direction = $(event.target).data('direction');
    this._sortBidders();
    this._removeAllSeries();
    this._cachedSeries = {
      sections: null,
      categories: null
    };
    return this._redrawChart();
  },

  _drawChart(selector) {
    const _this = this;
    return this._chart = Highcharts.chart(selector, {
      title: {
        text: ''
      },
      chart: {
        type: 'bar',
        width: this._chartWidth - 40
      },
      credits: false,
      yAxis:
        [
          _.extend(_.clone(this._defYAxisConfig), {
            stackLabels: {
              align: 'right',
              enabled: true,
              useHTML: true,
              y: 20,
              formatter() {
                const id = _this._bidsOrder[this.x];
                const bid = _.find(_this._rawData.bids, {id});
                return _this._drawStackLabelForBidder(bid);
              }
            }
          }),
          // draw second yaxis to get values on top
          _.extend(_.clone(this._defYAxisConfig), {
            linkedTo: 0,
            opposite: true
          })
        ],
      xAxis: {
        labels: {
          enabled: false
        }
      },
      plotOptions: {
        series: {
          stacking: 'normal'
        }
      },
      series: this._seriesBySection(),
      width: this._chartWidth,
      legend: {
        align: 'left',
        symbolRadius: 0
      },
      navigation: {
        buttonOptions: {
          x: 40
        }
      },
      tooltip: {
        borderWidth: 0,
        backgroundColor: '#FFFFFF',
        useHTML: true,
        outside: true,
        followPointer: true,
        formatter() {
          const {
            evaluators
          } = _this._rawData;
          const bidEvaluations = _this._currentCategory === 'sections' ?
            _.where(_this._rawData.bid_evaluation_sections, {bid_id: this.point.meta.bidId, category: this.point.meta.category, bid_evaluation_template_section_id: this.point.meta.template_id})
          :
            _.where(_this._rawData.grouped_evaluations.by_category_and_evaluator, {bid_id: this.point.meta.bidId, category: this.point.meta.category});
          return _this._drawToolTipTable(evaluators, bidEvaluations.sort((l, r) => l.evaluator_id - r.evaluator_id));
        }
      }
    });
  },

  _blurNotFinishedEvaluations() {
    const bidIds = _.where(this._rawData.bid_evaluations, { finished: false });
    const blurList = {};
    _.each(bidIds, el => blurList[el.bid_id] = true);
    return _.each(this._bidsOrder, function(el, index) {
      if (blurList[el]) { return $('.highcharts-series').find(`:nth-child(${index + 1})`).css('opacity', 0.5); }
  });
  },

  initialize(selector, data) {
    this._rawData = data;
    this._setWidth(selector);
    this._bidsOrder = _.map(this._rawData.bids, bid => bid.id);
    this._drawChart(selector);
    this._blurNotFinishedEvaluations();

    $('#category-section-drop .chart-type').on('click', _.bind(this.changeCategories, this));
    $('#sort-by-drop .chart-type').on('click', _.bind(this._changeOrder, this));

    return $('.highcharts-container, svg:not(:root)').css('overflow', 'visible');
  }
};
